<template>
  <my-modal>
    <div id="modal-template">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h4 class="text-primary mb-0">
              <i class="fas fa-file-contract btn-icon-wrapper btn-icon-sm"></i>
              XLS de libro digital
            </h4>
          </div>
          <div class="modal-body">
            <div class="row justify-content-center w-100">
              <h4 class="text-center mb-3 col-12">Seleccionar período</h4>
              <float-label label="MES:" clase="col-md-4">
                <select id="mes" class="form-control" v-model="mes">
                  <option v-for="m in meses" :value="m" :key="m">
                    {{ m }}
                  </option>
                </select>
              </float-label>
              <float-label label="AÑO:" clase="col-md-4">
                <select id="year" class="form-control" v-model="year">
                  <option v-for="n in years" :key="n" :value="n">
                    {{ n }}
                  </option>
                </select>
              </float-label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="cerrarModal">
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="selectPeriodo"
            >
              Descargar
            </button>
          </div>
        </div>
      </div>
    </div>
  </my-modal>
</template>
<script>
import FloatLabel from "@/components/layouts/FloatLabel";
import MyModal from "@/components/layouts/MyModal";
import axios from "axios";
export default {
  name: "ModalSelectLibroDigitalPeriodo",
  components: {
    FloatLabel,
    MyModal
  },
  data() {
    return {
      loading: false,
      fecha: new Date(),
      mes: "",
      year: null,
    };
  },
  computed: {
    years: function () {
      let array = [];
      for (let index = 2020; index <= 2035; index++) {
        array.push(index);
      }
      return array;
    },
    meses: function () {
      return [
        "ENERO",
        "FEBRERO",
        "MARZO",
        "ABRIL",
        "MAYO",
        "JUNIO",
        "JULIO",
        "AGOSTO",
        "SEPTIEMBRE",
        "OCTUBRE",
        "NOVIEMBRE",
        "DICIEMBRE",
      ];
    },
  },
  mounted() {

    this.year = this.$moment(this.fecha).format("YYYY");
    this.mes = this.$moment(this.fecha).format("MMMM").toUpperCase();
  },
  methods: {
    cerrarModal() {
      this.$emit("cerrarSelectPeriodo");
    },
    selectPeriodo() {
      let periodo = this.mes + " " + this.year;
      window.location.href =
        axios.defaults.baseURL + "/libro-digital/liquidacion?periodo=" + periodo+"&institucionId="+axios.defaults.headers.common['institucionId'];
    },
  },
};
</script>
